<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  @import '~animate.css/animate.min.css';
  @import '~@riophae/vue-treeselect/dist/vue-treeselect.min.css';
  @import '~flag-icon-css/css/flag-icon.css';
  @import '~devextreme/dist/css/dx.common.css';
  @import '~devextreme/dist/css/dx.light.css';
  @import '~vue2-daterange-picker/dist/vue2-daterange-picker.css';
</style>